<template>
	<search-list ref="sl" :where="where" :order="order" :attributes="attributes" api-path="/offer/list" notSearchAll :searchKeys="searchKeys">
		<div class="search-condition">
			<div class="row">
				<!-- <mm-lc title="Period">
					<mm-date-range not-default-value date-value v-model="where.sync_at"/>
				</mm-lc> -->
				<mm-lc title="Adv" class="gim-select">
					<mm-adv-select no_paused v-model="where.adv_id" multiple />
				</mm-lc>
				<mm-lc title="Status" class="gim-select">
					<mm-offer-status v-model="where.status" multiple />
				</mm-lc>
				<mm-lc title="Manual Status" class="gim-select">
					<mm-offer-status v-model="where.manual_status" multiple />
				</mm-lc>
				<mm-lc title="Platform" class="gim-select">
					<mm-offer-platform v-model="where.platform" multiple />
				</mm-lc>
				<mm-lc title="Country" class="gim-select">
					<mm-offer-geos v-model="where.geos" multiple />
				</mm-lc>
				<mm-lc title="Currency" class="gim-select">
					<mm-offer-currency v-model="where.currency" multiple />
				</mm-lc>
				<mm-lc title="Pricing Model" class="gim-select">
					<mm-offer-pricing-model v-model="where.pricing_model" multiple />
				</mm-lc>
				<mm-lc title="WhiteOnly" class="gim-select">
					<mm-tf-select v-model="where.whiteOnly"/>
				</mm-lc>
				<mm-lc title="Group" class="gim-select">
					<mm-select multiple :options="groupOptions" return-array v-model="attributes"/>
				</mm-lc>
			</div>
			<!-- <div class="row">
				<mm-lc title="Server Click">
					<el-switch v-model="where.server_click"></el-switch>
				</mm-lc>
			</div> -->
		</div>
		<div class="switch-select" slot="switchActions">
			<div class="switch-actions">
				<span>Is Nice:&nbsp;&nbsp;</span>
				<el-switch v-model="where.nice"></el-switch>
			</div>
			<div class="switch-actions">
				<span>New Offer:&nbsp;&nbsp;</span>
				<el-switch v-model="is_new"></el-switch>
			</div>
			<!-- <div class="switch-actions">
				<span>WhiteOnly:&nbsp;&nbsp;</span>
				<mm-tf-select v-model="where.whiteOnly"/>
			</div> -->
		</div>

		<el-dropdown size="mini" trigger="click" slot="statusAction">
			<el-button size="small" type="primary" icon="el-icon-edit">
				Batch Op
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item class="status-active" @click.native="batchOp(switchStatus,'active')">Switch to Active</el-dropdown-item>
				<el-dropdown-item class="status-paused" @click.native="batchOp(switchStatus,'paused')">Switch to Paused</el-dropdown-item>
				<el-dropdown-item class="status-pending" @click.native="batchOp(switchStatus,'pending')">Switch to Pending</el-dropdown-item>
				<el-dropdown-item @click.native="batchOp(batchWhiteOnly,true)">WhiteOnly</el-dropdown-item>
				<el-dropdown-item @click.native="batchOp(batchWhiteOnly,false)" class="status-paused">Cancel WhiteOnly</el-dropdown-item>
				<el-dropdown-item @click.native="()=>showCopyTos2s=true" class="status-active">Copy to S2S</el-dropdown-item>
				<el-dropdown-item @click.native="()=>showEditTimezone=true">Edit Timezone</el-dropdown-item>
				<el-dropdown-item @click.native="()=>showEditPo=true">Edit Po</el-dropdown-item>
				<el-dropdown-item @click.native="()=>showEditCamp=true">Edit Campaign</el-dropdown-item>
				<el-dropdown-item @click.native="()=>showEditCap=true">Edit Cap</el-dropdown-item>
				<el-dropdown-item @click.native="()=>showRemark=true">Remark</el-dropdown-item>
				
				<el-dropdown-item @click.native="batchOp(switchOpenPayout,1)">OpenPayout</el-dropdown-item>
				<el-dropdown-item @click.native="batchOp(switchOpenPayout,0)" class="status-paused">Cancel OpenPayout</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-button slot="actions" type="success" class="el-icon-document-add" @click="create" />

		<mm-table slot="dataTable" slot-scope="res" :res="res" @selection-change="selectionChange"  @sort-change="sortChange">
			<template slot-scope="etc">
			<el-table-column type="selection" fixed="left"/>
			<el-table-column label="Offer Id" prop="offer_id" min-width="150" fixed="left" :renderHeader="etc.renderHeaderCopy">
				<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offer_id" :row_name="sp.row.offer_id">
					<el-button type="text" icon="el-icon-edit-outline" class="copy-offer-id" @click="copyOfferId(sp.row.offer_id)"/>
				</mm-get-detail>
			</el-table-column>
			<el-table-column label="Offer Name" prop="offer_name" min-width="120" fixed="left" :renderHeader="etc.renderHeaderCopyNew('\r')">
				<div slot-scope="sp">
					<span :class="sp.row.manual?'manual-offer':''">
						{{sp.row.offer_name}}
					</span>
				</div>
			</el-table-column>
			<el-table-column label="Adv Offer Id" prop="adv_offer_id" width="130" :renderHeader="etc.renderHeaderCopyNew('\r')"/>
			<el-table-column label="Adv">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>

			<el-table-column label="Regions" prop="geo" width="90">
				<div slot-scope="sp">
					<span v-if="sp.row.geo && sp.row.geo.length < 9">{{ sp.row.geo }}</span>
					<el-tooltip :content="sp.row.geo" v-else>
						<span>{{ sp.row.geo && sp.row.geo.substr(0, 8) }}...</span>
					</el-tooltip>
				</div>
			</el-table-column>
			<el-table-column label="Platform" prop="platform" />
			<el-table-column label="Package Name" prop="package_id" v-if="containGroup('package_id')" width="120" />
			<!-- <el-table-column label="PackageId" prop="package_id" /> -->
			<el-table-column label="Pricing Info" prop="offer_price" width="128" sortable="custom">
				<span slot-scope="sp">{{sp.row.offer_price+'/'+sp.row.pricing_model.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Currency" prop="currency" width="90" >
				<span slot-scope="sp">{{sp.row.currency && sp.row.currency.toUpperCase() || 'USD'}}</span>
			</el-table-column>
			<el-table-column label="Daily Click" prop="daily_click" width="60" />
			<el-table-column label="Daily Cap" prop="daily_cap" width="60" />
			<el-table-column label="Timezone" prop="timezone" width="90" />
			<el-table-column label="Nice" prop="nice" width="55">
				<span slot-scope="sp">{{sp.row.nice?'Nice':''}}</span>
			</el-table-column>
			<el-table-column label="White Only" prop="whiteOnly" width="100">
				<span slot-scope="sp">{{sp.row.whiteOnly?'whiteOnly':''}}</span>
			</el-table-column>
			<el-table-column label="Time" min-width="150">
				<template slot-scope="sp">
					<el-row>{{timeFormat(sp.row.create_at)}}</el-row>
					<el-row>{{timeFormat(sp.row.sync_at)}}</el-row>
				</template>
			</el-table-column>
			<el-table-column label="Trace Result" v-if="containGroup('trace_result')" width="100" >
				<template slot-scope="sp">
					<mm-trace-result :histories="sp.row.histories" :stop_reason="sp.row.stop_reason" :redirections="sp.row.redirections"/>
				</template>
			</el-table-column>

			<el-table-column label="KPI" prop="kpi" v-if="containGroup('kpi')" width="120"/>
			<el-table-column label="Pid" prop="pid" v-if="containGroup('pid')" width="120"  :renderHeader="etc.renderHeaderCopyNew(`\r`)"/>
			<el-table-column label="Events" prop="events" v-if="containGroup('events')" width="220">
				<template slot-scope="sp">
					<div
						v-for="(event, key) in sp.row.events"
						:key="key"
					>
						<el-tooltip class="item" effect="dark" :content="`${event.event_name} / ${event.event_value} / ${event.payout}`" placement="top-start">
							<span>{{ event.event_value }} / {{ event.payout }}</span>
						</el-tooltip>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="Preview Link" prop="preview_url" v-if="containGroup('preview_url')" width="120" />
			<el-table-column label="Remark" prop="remark" width="120" >
				<template slot-scope="sp">
					<div v-if="!sp.row.remark || sp.row.remark.length <= 10">{{ sp.row.remark }}</div>
					<el-popover
						v-else
						placement="top-start"
						width="200"
						trigger="click"
					>
						<div v-html="sp.row.remark.replace(/\n/g, '<br/>')">
						</div>
						<el-button slot="reference" type="text">{{ sp.row.remark.substring(0, 20) + '...' }}</el-button>
					</el-popover>
				</template>
			</el-table-column>
			<el-table-column label="Status" prop="status" fixed="right">
				<span slot-scope="sp" :class="'status-'+sp.row.status.trim()">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Manual Status" prop="manual_status" fixed="right" width="85">
				<span slot-scope="sp" :class="'status-'+sp.row.manual_status">{{sp.row.manual_status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="action" fixed="right">
				<template slot-scope="sp">
					<el-dropdown szie="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item @click.native="edit(sp.row)">Edit</el-dropdown-item>
							<el-dropdown-item @click.native="copyToCreate(sp.row)">Copy to Create</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
			</template>
		</mm-table>
		<el-dialog :visible.sync="showEditCamp">
			<span slot="title">Edit Campaigns</span>
			<el-form label-width="200px" class="edit-camp">
				<el-form-item label="Channel" required>
					<mm-channel-select no_paused v-model='camp.channel_ids' multiple />
				</el-form-item>
				<div class="camp-item">
					<span>
						<el-form-item label="White">
							<el-switch v-model='camp.white' />
						</el-form-item>
						<el-form-item label="Block Click">
							<el-switch :active-value="1" v-model='camp.block_click' />
						</el-form-item>
						<el-form-item label="Block Conver">
							<el-switch :active-value="1" v-model='camp.block_conv' />
						</el-form-item>
					</span>
					<span>
						<el-form-item label="Daily Click Cap">
							<div class="percent-input">
								<el-input type="number" :controls="false" v-model='camp.click_cap'/>
							</div>
						</el-form-item>
						<el-form-item label="Daily Cap">
							<div class="percent-input">
								<el-input type="number" :controls="false" v-model='camp.daily_cap'/>
							</div>
						</el-form-item>
						<el-form-item label="No Block Conv" >
							<el-switch :active-value="1" v-model="camp.no_block_conv"/>
							</el-form-item>
						<el-form-item label="Payout Rate(%)"  >
							<div class="percent-input">
								<mm-input-number-percent v-model="camp.price_percent" limit_min="0"/>
							</div>
						</el-form-item>
						<el-form-item label="Deduction Rate(%)"  >
							<div class="percent-input">
								<mm-input-number-percent v-model="camp.def" limit_min="-3"/>
							</div>
						</el-form-item>
					</span>
				</div>
				<el-form-item label="Block Reason">
					<el-input type="textarea" rows="3" v-model='camp.block_reason' />
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="editCamp">Save</el-button>

				</el-form-item>
			</el-form>

		</el-dialog>
		<el-dialog :visible.sync="showEditTimezone">
			<span slot="title">Edit Timezone</span>
			<el-form label-width="200px" class="edit-timezone">
				<el-form-item label="Timezone" required>
                    <mm-time-zone v-model="timezone" />
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="editTimezone">Save</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="showCopyTos2s">
			<span slot="title">Copy To S2S</span>
			<el-form label-width="200px" class="edit-timezone">
				<el-form-item label="copyTimes" required>
                    <el-input-number :min="1" :max="10" v-model="copyTimes" />
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="copyTos2s">Save</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="showEditCap">
			<span slot="title">Edit Cap</span>
			<el-form label-width="200px" class="edit-timezone">
				<el-form-item label="Cap">
					<el-switch v-model="setDailyCap" style="margin-right:10px;"></el-switch>
					<el-input-number :disabled="!setDailyCap" :min="0" v-model="dailyCap" />
				</el-form-item>
				<el-form-item label="Click">
					<el-switch v-model="setDailyClick" style="margin-right:10px;"></el-switch>
					<el-input-number :disabled="!setDailyClick" :min="-1" v-model="dailyClick" />
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="editCap">Save</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="showRemark">
			<span slot="title">Remark</span>
			<el-form label-width="200px" class="edit-timezone" ref="poForm"  :model="poBody">
				<el-form-item label="Status" prop="status" required>
					<mm-offer-status v-model="remarkBody.status" />
				</el-form-item>
				<el-form-item label="Remark" prop="remark" required>
					<el-input v-model="remarkBody.remark" type="textarea" :rows="5" />
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="remark">Save</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="showEditPo">
			<span slot="title">Offer Pirce</span>
			<el-form label-width="200px" class="edit-timezone" ref="poForm"  :model="poBody">
				<el-form-item label="Offer Price" prop="offer_price" required>
					<el-input type="number" v-model="poBody.offer_price" :min="0"></el-input>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="batchEditPo">Save</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>
	</search-list>
</template>

<script>
export default {
	data() {
		const groupOptions=[
			{label:'Trace Result',value:'trace_result'},
			{label:'KPI',value:'kpi'},
			{label:'Preview Link',value:'preview_url'},
			{label:'Package Name',value:'package_id'},
			{label:'Pid',value:'pid'},
			{label:'Events',value:'events'},
		]
		const searchKeys = {
			offer_id: { label: "Offer Id" },
			adv_offer_id: { label: "Adv Offer Id" },
			offer_name: { label: "Offer Name", fuzzy: true },
			package_id: { label: "Package Id", fuzzy: true },
			app_name: { label: "App Name" },
			pid: { label: "Pid", fuzzy: true },
		};
		return {
			where: {},
			order: [['sync_at',-1]],
			attributes:[],
			groupOptions,
			camp: {},
			searchKeys,
			selected: [],
			showEditCamp: false,
			is_new: false,
			showEditTimezone: false,
			timezone: '',
			showCopyTos2s: false,
			copyTimes: 1,
			showEditCap: false,
			dailyCap: 0,
			dailyClick: 0,
			setDailyCap: true,
			setDailyClick: true,
			showRemark: false,
			remarkBody: {},
			showEditPo: false,
			poBody: {
				offer_price: 0,
			},
		};
	},
	watch: {
		is_new(type) {
			if (type) {
				const start = new Date().setUTCHours(0,0,0,0);
				this.where.create_at = { $gte: start };
			} else {
				delete this.where.create_at;
			}
			// console.log(this.where);
		}
	},
	methods: {
		copyOfferId(offer_id) {
			this.$copyText(`${offer_id}`).then((res) => {
				this.$message({
					type:'success',
					message:'Copied ' + offer_id,
				})
			}).catch((e) => {
				console.log('e', e);
			});
		},
		containGroup(key){
			if(this.attributes && this.attributes.indexOf(key)>-1){
				return true;
			}
			return false;
		},
		timeFormat(date) {
			date = new Date(date);
			return this.$utils.date_format(date, "YYYY-MM-DD hh:mm:ss");
		},
		selectionChange(v) {
			this.selected = v.map(v => v["offer_id"]);
		},
		async batchOp(fn, value) {
			if (this.selected.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
			} else {
				await fn(value);
				await this.$refs.sl.refresh();
				this.$refs.dataTable.$el.$refs.mm_table.clearSelection();
				this.selected = [];
			}
		},
		async switchStatus(status) {
			await this.$post("/offer/switchStatus", {
				offer_ids: this.selected,
				status
			});
		},
		async editTimezone() {
			if (this.timezone !== '') {
				await this.$post("/offer/batchEditTimezone", {
					offer_ids: this.selected,
					timezone: this.timezone
				});
			}
		},
		async editCap() {
			if (!this.setDailyCap && !this.setDailyClick) {
				this.$message({
					type: 'error',
					message: 'Please select at least one of Cap or Click to edit'
				});
				return;
			}
			const body = {
				offer_ids: this.selected,
			};
			 if (this.setDailyCap) {
				body.daily_cap = this.dailyCap;
			}
			 if (this.setDailyClick) {
				body.daily_click = this.dailyClick;
			 }
			await this.$post("/offer/batchEditCap", body);
		},
		async batchWhiteOnly(whiteOnly) {
			await this.$post("/offer/batchWhiteOnly", {
				offer_ids: this.selected,
				whiteOnly
			});
		},
		async switchOpenPayout(open_payout) {
			await this.$post("/offer/batchOpenPayout", {
				offer_ids: this.selected,
				open_payout
			});
		},
		async copyTos2s() {
			await this.$post("/offer/copyTos2s", {
				offer_ids: this.selected,
				times: this.copyTimes || 1,
			});
		},
		create() {
			window.open("/offerCreate");
		},
		edit(row) {
			window.open(`/offerEdit?id=${row.offer_id}`);
		},
		async editCamp() {
			await this.$post("/offer/editCamp", {
				offer_ids: this.selected,
				camp: this.camp
			});
			this.showEditCamp = false;
		},
		async sortChange(column){
			const order = this.order;
			if(column.order == 'ascending'){
				order[0] = [column.prop, 1];
			}else if(column.order == 'descending'){
				order[0] = [column.prop, -1];
			}else {
				order[0] = ['sync_at',-1];
			}
			await this.$refs.sl.refresh();
			this.order[0] = ['sync_at',-1];
		},
		copyToCreate(row) {
			window.open("/offerCreate?copy_id="+row.offer_id);
		},
		async remark() {
			if (this.selected.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
			} else {
				await this.$validate(this.$refs.remarkForm);
				await this.$post('/offer/switchStatus', {
					...this.remarkBody,
					offer_ids: this.selected,
				});
				this.showRemark = false;
				await this.$refs.sl.refresh();
			}
		},
		async batchEditPo() {
			if (this.selected.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
			} else {
				await this.$validate(this.$refs.poForm);
				await this.$post('/offer/batchEditPo', {
					...this.poBody,
					offer_ids: this.selected,
				});
				this.showEditPo = false;
				await this.$refs.sl.refresh();
			}
		}
	}
};
</script>

<style scoped>
.edit-camp {
	width: 400px;
	height: 500px;
}
.camp-item {
	display:flex;
}
.percent-input {
	width: 100px;
}
.el-form-item {
	width: 500px;
}
.search-condition {
	display: flex;
	flex-direction: column;
}
.row {
	display: flex;
	flex-direction: row;
	margin-bottom: 5px;
}
.copy-offer-id{
	display: inline;
	margin-left: 5px;
}
.manual-offer{
	color:brown;

}
.switch-actions {
	padding-right: 10px;
}
.switch-select {
	display: flex;
	align-items: center;
	padding-left: 20px;
	font-size: 13px;
}
</style>


